export const environment = {
  production: true,
  hmr: false,
  debug: false,
  client: 'GM-US',
  hostName: 'gmus-analytics-prod.azurewebsites.net',
  environmentName: 'production',
  appName: 'GM-US Analytics',
  ssoPassword: 'ShiftDigital#123',
  applicationInsights: {
    instrumentationKey: '00458e01-9f2b-45f9-b4a7-d29c878e2cae'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Eastern Standard Time',
  showLocaleSelector: 'true',
  numberOfMonthsToShowDefault: 12,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1,2],
  closeRateLookbackMonths: 3,
  defaultChartColors: ['#1b365c', '#47ddfc', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  baseApiUri: 'https://gmus-analytics-api-prod.azurewebsites.net/api',
  authUri: 'https://gmus-analytics-api-prod.azurewebsites.net/token',
  baseV5ApiUri: 'https://gmus-analytics-apiv5-prod.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: false,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/gm-us/favicon.ico',
  loginRedirectUrl:  'https://launcher.myapps.microsoft.com/api/signin/0c3ca1a4-b15e-4719-8900-f509c9c9c9f0?tenantId=5de110f8-2e0f-4d45-891d-bcf2218e253d',
  logoutRedirectUrl: 'https://dealer.autopartners.net/portal/us/Pages/default.aspx',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
  v5Reports: [
    'WebsiteOverview',
    'WebsiteScorecard',
    'TradeInOverview',
    'ChatOverview',
    'DigitalAdvertisingTier2Dashboard',
    'DigitalAdvertisingDashboard',
    'DigitalRetailingOverview',
    'SalesForecastingSummary'
  ]
};
